'use client';
import { Loader } from '../Loader/Loader.js';

const IDENT = 'Button';
const defaultProps = {
    variant: 'default',
    size: 'md1',
    transitionDuration: 200,
    contentGap: '2s',
    loader: Loader
};

export { IDENT, defaultProps };
//# sourceMappingURL=Button.contract.js.map
